/* export const RAZORPAY_KEY = "rzp_test_sww6eyRpjsDmO2" */
export const RAZORPAY_KEY = "rzp_live_Hw5b76BfR6Q8A4";

export const API_URLS = {
  sendOTP: "/blog/get-otp-api/",
  verifyOTP: "/blog/verify-user-otp-api/",
  country_list_api: "/blog/country-api/",
  state_list_api: "/blog/state-api/",
  city_list_api: "/blog/city-api/",
  new_api: "/blog/news-api/",
  event_api: "/blog/event-api/",
  give_donation: "/blog/give-donation-api/",
  payment_success: "/blog/donation-payment-success-api/",
  certificate_plan: "/blog/certificate-plan-api/",
  get_ceritificate: "/blog/buy-certificate-api/",
  get_ceritificate_payment_success:
    "/blog/buy-certificate-payment-success-api/",
  policy_privarcy: "/blog/privacy-policy/",
  return_policy: "/blog/return-policy/",
  customer_list: "blog/employee-list-for-chat-api/",

  chat_list: "blog/employee-chat-list-api/",
  chat_qa: "blog/chat-qa-api/",
  chat_bot_msg: "blog/first-time-show-question-api/",
  images: "blog/upload-image-to-s3-api/",
  unmatched: "blog/unmatch-question-api/",
  allimages: "s3-bucket-data-api/",
  profile: "blog/user-profile-api-for-admin-panel/",
  waitinguser: "blog/waiting-employee-list-for-query-api/",
};

export const protectedRoutes = {
  profile: "/blog/engineer-profile-api/",
  paymentHistory: "/blog/engineer-payment-history-api/",
  category_api: "/blog/blog-category-api/",
  sub_category_api: "/blog/blog-subcategory-api/",
  blog: "/blog/blog-api/",
  news: "/blog/news-api/",
  gallery: "/blog/gallery-api/",
  gallery_image: "/blog/gallery-image-api/",
  slider: "/blog/Slider-api/",
  banner: "/blog/banner-api/",
  dashboard: "/blog/dashboard-api-of-admin/",
  enginneer: "/blog/engineer-list-api/",
  engineer_status: "/blog/engineer-activate-deactivate-api/",
  engineer_approval: "/blog/engineer-approval-api/",
  create_payment: "/blog/create-payment-api/",
  contact_us: "/blog/contact-us-list-admin-api/",
  event: "/blog/event-api/",
  status_plan_certificate: "/blog/certificate-plan-activate-deactivate-api/",
  donation_list: "/blog/donation-list-api/",
  buy_certificate: "/blog/buy-certificate-api/",
  buy_cerificate_payment_success: "/blog/buy-certificate-payment-success-api/",
  our_members: "/blog/our-members-plan-api/",
  youtubeFolder: "/blog/video-api/",
  Youtube_link: "/blog/video-url-api/",

  case_study: "/blog/api-for-case-study/",

  pageDesign: "/page-design-setup-api/",
  subMenu: "blog/sub-menu-api/",
  subSubManu: "/blog/sub-sub-menu-api/",
  document: "blog/super-admin-project-documentation-api/",
};

export const websocket_Url = {
  internal_chat_notification: "ws/chat-notification/",
  all_notification: "ws/all-notifications/",
};
